<template>
  <div id="index_input">
    <div class="lowerinput" :class="isactive?'input_one_active':''">
      <!-- ||input_prohibit?'input_two_active':''" -->
      <span class="lowerinput_input" :class="inputtext?'input_text':''">{{names}}</span>
      <input
        class="inputbox"
        type="text"
        id="WarehouseFullName"
        ref="WarehouseFullName"
        :disabled="input_prohibit"
        @focus="Focus($event)"
        @blur="Blur"
        @input="changeinput"
        v-model="value1"
        :placeholder="placeholders"
      />
      <!-- <i
        class="el-icon-warning"
        v-if="inputtext&&isShow"
        style="color:red;white-space: nowrap;line-height: 28px;"
      >该值为必填项</i>-->
      <i class="plus" :class="plus?'el-icon-plus':''" @click="plusclick"></i>
      <i class="plus" :class="search?'el-icon-search':''" @click="searchclick"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: "lowerinput",
  data() {
    return {
      names: this.name,
      isactive: false,
      plus: this.iconplus,
      search: this.iconsearch,
      input_prohibit: this.prohibit,
      value1: this.value,
      inputtext: this.input_text,
      placeholders: this.placeholder
    };
  },
  props: {
    value: [String, Number],
    name: {
      type: String,
      default: "我需要一个值"
    },
    placeholder: {
      type: String,
      default: ""
    },
    input_text: {
      type: Boolean,
      default: false
    },
    iconplus: {
      type: Boolean,
      default: false
    },
    iconsearch: {
      type: Boolean,
      default: false
    },
    prohibit: {
      type: Boolean,
      default: false
    },
    field: { type: String }
  },
  methods: {
    childAction() {
      this.$refs.WarehouseFullName.focus();
    },
    changeinput() {
      this.$emit("changeinput", this.value1, this.field);
    },
    plusclick() {
      this.$emit("plusclick");
    },
    searchclick() {
      this.$emit("searchclick");
    },
    Blur() {
      this.$emit("Blur");
      this.isactive = false;
    },
    Focus() {
      this.$emit("Focus");
      this.isactive = true;
      event.currentTarget.select();
    }
  },
  mounted() {
    this.$on("footer", val => {
      this.childAction(ind);
    });
  },
  watch: {
    value() {
      this.value1 = this.value;
      // console.log('66547')
    }
  }
};
</script>

<style lang="less">
#index_input {
}
.lowerinput {
  width: 100%;
  height: 28px;
  border: 1px solid #e4e7ed;
  border-radius: 5px;
  display: flex;
  .lowerinput_input {
    white-space: nowrap;
    line-height: 28px;
    font-size: 14px;
    margin-left: 5px;
    font-weight: bold;
  }
  .input_text::after {
    content: "*";
    color: red;
  }
  .inputbox {
    border: none;
    width: 100%;
    height: 100%;
    outline: none;
    text-indent: 8px;
  }
  input:disabled {
    background-color: #fff !important;
  }
  .plus {
    line-height: 28px;
    margin-right: 6px;
  }
  .plus:hover {
    cursor: pointer;
  }
}
.lowerinput:hover {
  border: 1px solid #2594ff;
  .lowerinput_input {
    color: #2594ff;
  }
}
.input_one_active {
  border: 1px solid #2594ff;
  .lowerinput_input {
    color: #2594ff;
  }
}
.input_two_active {
  background-color: #ccc;
  .inputbox {
    background-color: #ccc;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Input/lowerinput/lowerinput.vue